/**
 * RouteSuspense — the boundary + branded fallback for route-level code
 * splitting (2026-06-11). Each page chunk downloads on first visit; while it
 * does, this renders a quiet centered loader instead of a blank screen.
 * Used at two altitudes: around the public <Routes> (App) and around the
 * authenticated <Outlet> (Layout) so in-app navigation never blanks the shell.
 */

import { Suspense } from 'react';
import Skeleton, { SkeletonGroup } from './Skeleton';

export default function RouteSuspense({ children }: { children: React.ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="min-h-[40vh] px-6 py-8">
          <SkeletonGroup label="Loading page…" className="max-w-3xl mx-auto space-y-4">
            {/* Page header */}
            <Skeleton className="h-7 w-56 rounded" />
            <Skeleton className="h-4 w-80 rounded" />
            {/* Content block */}
            <Skeleton className="h-48 w-full rounded-xl mt-2" />
          </SkeletonGroup>
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
